import React from 'react'
import MiPerfil from '../../components/perfil/MiPerfil';
import Layout from '../../components/layout/Layout';

const MiPerfilPage = () => {
  return ( <Layout children={<MiPerfil />} /> )
}

export default MiPerfilPage